<mat-drawer-container class="container" [hasBackdrop]="false">
  <lig-navigation></lig-navigation>

  <div class="main">
    <lig-side-navigation></lig-side-navigation>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <mat-drawer
    #drawer
    class="sidenav"
    mode="over"
    position="end"
    autoFocus="false"
    (keydown.escape)="drawer.close()"
    disableClose
  >
    <twc-component-portal></twc-component-portal>
  </mat-drawer>
</mat-drawer-container>
